import React, { useEffect, useMemo, useState } from "react";

export default function DashboardTeacherGoalsCard({
  theme,
  selectedDepartment,
  userProfile,
  currentSlogan,
  currentGoals,
  defaultCollapsed = false,
}) {
  const [isCollapsed, setIsCollapsed] = useState(defaultCollapsed);

  useEffect(() => {
    setIsCollapsed(defaultCollapsed);
  }, [defaultCollapsed, selectedDepartment]);

  const safeGoals = useMemo(
    () => (Array.isArray(currentGoals) ? currentGoals.filter(Boolean) : []),
    [currentGoals]
  );

  const firstGoal = safeGoals[0] || "핵심 목표 확인";

  return (
    <div className="bg-white rounded-2xl p-4 shadow-sm border border-gray-100 overflow-hidden mb-2">
      <button
        type="button"
        onClick={() => setIsCollapsed((prev) => !prev)}
        className="w-full min-h-11 flex items-center justify-between gap-3 text-left"
      >
        <div>
          <h3 className="font-do-hyeon text-[15px] font-black text-gray-800">
            {selectedDepartment || userProfile?.deptName || "부서"} 목표
          </h3>
          <p className="text-[11px] text-gray-500 font-bold truncate">"{currentSlogan}"</p>
        </div>
        <span className={`text-[11px] font-black ${theme.text}`}>
          {isCollapsed ? "펼치기" : "접기"}
        </span>
      </button>

      {isCollapsed ? (
        <div className="mt-3 rounded-xl border border-gray-100 bg-gray-50 px-3 py-2.5">
          <p className="text-[11px] font-bold text-gray-600">
            핵심 목표 {safeGoals.length}개
          </p>
          <p className="text-[12px] font-black text-gray-800 truncate mt-0.5">
            1) {firstGoal}
          </p>
        </div>
      ) : (
        <div className="space-y-2 mt-4">
          {safeGoals.map((goal, idx) => (
            <div key={idx} className="flex items-center gap-3 bg-gray-50 rounded-xl px-3 py-2.5 border border-gray-100">
              <div className={`w-6 h-6 rounded-full ${theme.bg} flex items-center justify-center text-white text-xs font-bold`}>
                {idx + 1}
              </div>
              <span className="text-sm font-bold text-gray-700">{goal}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
